import router from "../../router"
import store from "../../store"
export default {
  openPath (path) {
    if (path !== store.state.activeMenu) {
      router.push(path)
      // store.commit('set_activeMenu', path)
    }
  }
}